export function MailBadge({ count, className = "", testId }) {
  if (!count || count <= 0) return null;
  const label = count > 99 ? "99+" : String(count);
  return (
    <span
      data-testid={testId}
      className={`text-[10px] font-semibold px-1.5 py-0.5 rounded-md tp-brand-gradient text-white shadow-md shadow-fuchsia-600/30 ${className}`}
    >
      {label}
    </span>
  );
}

export default MailBadge;
